import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/projectActions';
import * as events from '../constants/eventActions';
import weekApprovalUiReducer from "../reducers/weekApprovalUiReducer";
import weekApprovalUiActions from "./weekApprovalUiActionCreators";
import {getUnbilledHoursProject} from "../constants/projectActions";

const projectActions = {

    approveHoursProject(projectKey, taskKey, approvedHourKey) {
        return dispatch => dispatch(actions.approveHoursProject(projectKey, taskKey, approvedHourKey));
    },

    archive(project) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .post(env.tashi + '/projects/' + project.id + '/archive')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.archiveProject({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "archive project" }));
                    }

                    if (res.ok) {
                        dispatch(actions.archiveProject({ status: "success", project }));
                        dispatch(events.pushSuccessEvent({ data: "archive project" }));
                    } else {
                        dispatch(actions.archiveProject({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "archive project" }));
                    }
                });
        };
    },

    checkProjectName(projectName) {
      return dispatch => {
        let encodedProjectName = encodeURIComponent(projectName);
        request
          .get(env.tashi + `/projects/checkName/${encodedProjectName}/`)
          .withCredentials()
          .accept("application/json")
          .end((err, res) => {
            if (err) {
              dispatch(actions.checkProjectName({ status: "failure", data: err }));
            } else {
              dispatch(actions.checkProjectName({ status: "success", data: JSON.parse(res.text) }));
            }
          });
      };
    },

    checkProjectNameCV(project) {
        return dispatch => {

            request
                .post(env.tashi + '/projects/checkCV')
                .withCredentials()
                .accept('application/json')
                .send(project)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.checkProjectNameCV({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        let sameProjects = JSON.parse(res.text);
                        dispatch(actions.checkProjectNameCV({ status: "success", data: sameProjects }));
                    } else {
                        dispatch(actions.checkProjectNameCV({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    clearError() {
      return dispatch =>{
        dispatch(actions.clearError());
      };
    },

    create(project) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .post(env.tashi + '/projects/create')
                .withCredentials()
                .accept('application/json')
                .send(project)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createProject({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "create project" }));
                        return;
                    }

                    if (res.ok) {
                        let newProject = JSON.parse(res.text);

                        dispatch(actions.createProject({ status: "success", project: newProject }));
                        dispatch(events.pushSuccessEvent({ data: "create project" }));
                    } else {
                        dispatch(actions.createProject({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "create project" }));
                    }
                });
        };
    },

    delete(projectID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .post(env.tashi + '/projects/' + projectID + '/delete')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.deleteProject({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "delete project" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.deleteProject({ status: "success", projectID }));
                        dispatch(events.pushSuccessEvent({ data: "delete project" }));
                    } else {
                        dispatch(actions.deleteProject({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "delete project" }));
                    }
                });
        };
    },

    edit(project) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .post(env.tashi + '/projects/' + project.id + '/edit')
                .withCredentials()
                .accept('application/json')
                .send(project)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.editProject({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "edit project" }));
                        return;
                    }
                    let project = JSON.parse(res.text);
                    if (res.ok) {
                        dispatch(actions.editProject({ status: "success", project }));
                        dispatch(events.pushSuccessEvent({ data: "edit project" }));
                    } else {
                        dispatch(actions.editProject({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "edit project" }));
                    }
                });
        };
    },

    exportProjects(dateFrom, dateTo, fileName) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/export')
                .query({
                    dateFrom: dateFrom.format("YYYY-MM-DD")
                    , dateTo: dateTo.format("YYYY-MM-DD")
                })
                .accept('text/csv')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.exportProjects({ status: "failure", data: err }));
                        return;
                    } else {
                        dispatch(actions.exportProjects({ status: "success", data: res.text, fileName }));
                    }
                });
        };
    },

    isDeletable(projectID) {
        return dispatch => {
            request
                .get(env.tashi + '/projects/isDeletable/' + projectID)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.isDeletable({ status: "failure", data: err}));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data || data === false) {
                        dispatch(actions.isDeletable({ status: "success", data: data }));
                    } else {
                        dispatch(actions.isDeletable({ status: "failure", data: false }));
                    }
                });
        }
    },

    loadProjects() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.projects : null;

                    if (data) {
                        dispatch(actions.loadProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadByUser(userID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            // TODO .end will be called twice, once without error and once with error
            request
                .get(env.tashi + '/projects/search/findAllByUser')
                .accept('application/json')
                .withCredentials()
                .query({
                    user: userID
                })
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadProjectsByUser({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "load projects for user" }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.projects : null;

                    if (data) {
                        dispatch(actions.loadProjectsByUser({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadProjectsByUser({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadMyProjectsForWeekApproval(week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/findMyProjectsForWeekApproval/' + week)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadMyProjectsForWeekApproval({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "load my projects for week approval" }));
                        return;
                    }

                    let data = JSON.parse(res.text).projects;

                    if (data) {
                        dispatch(actions.loadMyProjectsForWeekApproval({ status: "success", data: data }));
                        dispatch(events.pushSuccessEvent({ data: "load my projects for week approval" }));
                    } else {
                        dispatch(actions.loadMyProjectsForWeekApproval({ status: "success", data: [] }));
                        dispatch(events.pushSuccessEvent({ data: "load my projects for week approval" }));
                    }
                });
        };
    },

    loadOtherProjectsForWeekApproval(week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/findOtherProjectsForWeekApproval/' + week)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadOtherProjectsForWeekApproval({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "load other projects for week approval" }));
                        return;
                    }

                    let data = JSON.parse(res.text).projects;

                    if (data) {
                        dispatch(actions.loadOtherProjectsForWeekApproval({ status: "success", data: data }));
                        dispatch(events.pushSuccessEvent({ data: "load other projects for week approval" }));
                    } else {
                        dispatch(actions.loadOtherProjectsForWeekApproval({ status: "success", data: [] }));
                        dispatch(events.pushSuccessEvent({ data: "load other projects for week approval" }));
                    }
                });
        };
    },

    pmLoadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/search/pm_findAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmLoadAllProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.projects : [];
                    if (data) {
                        dispatch(actions.pmLoadAllProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmLoadAllProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmLoadAllWithoutTasks() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/search/pm_findAllWithoutTasks')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmLoadAllProjectsWithoutTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.projects : [];

                    if (data) {
                        dispatch(actions.pmLoadAllProjectsWithoutTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmLoadAllProjectsWithoutTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmLoadArchived() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/findProjectsForPMByArchived/true')
                .accept('application/json')
                .withCredentials()
                .query({
                    archived: true
                })
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmLoadArchivedProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.pmLoadArchivedProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmLoadArchivedProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmLoadUnarchived() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/findProjectsForPMByArchived/false')
                .accept('application/json')
                .withCredentials()
                .query({
                    archived: false
                })
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmLoadUnarchivedProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.pmLoadUnarchivedProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmLoadUnarchivedProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/search/pmo_findAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadAllProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.projects;

                    if (data) {
                        dispatch(actions.pmoLoadAllProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadAllProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadAllProjectsForUsersOverview() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/pmoFindAllForUsersOverview')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadAllProjectsForUsersOverview({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.pmoLoadAllProjectsForUsersOverview({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadAllProjectsForUsersOverview({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadArchived() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/findProjectsForPMOByArchived/true')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadArchivedProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.pmoLoadArchivedProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadArchivedProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadUnarchived() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .get(env.tashi + '/projects/findProjectsForPMOByArchived/false')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadUnarchivedProjects({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.pmoLoadUnarchivedProjects({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadUnarchivedProjects({ status: "success", data: [] }));
                    }
                });
        };
    },

    setCurrentView(viewName) {
        return dispatch => dispatch(actions.setCurrentView(viewName));
    },

    setSelectedProject(project) {
        return dispatch => dispatch(actions.setSelectedProject(project));
    },

    syncProjects() {
      return dispatch => {
        request.post(env.tashi + '/projects/sync').withCredentials().accept('application/json')
          .end((err, res) => {
            debugger;
            if (err) {
              dispatch(events.pushErrorEvent({ data: "sync all projects" }));
            }

            if (res) {
              dispatch(events.pushSuccessEvent({ data: "sync all projects" }));
            }
          });
      };
    },

    unarchive(project) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForProjectState());

            request
                .post(env.tashi + '/projects/' + project.id + '/unarchive')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.unarchiveProject({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "unarchive project" }));
                    }

                    if (res.ok) {
                        dispatch(actions.unarchiveProject({ status: "success", project }));
                        dispatch(events.pushSuccessEvent({ data: "unarchive project" }));
                    } else {
                        dispatch(actions.unarchiveProject({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "unarchive project" }));
                    }
                });
        };
    },

    getUnbilledHours(projectId) {
      return dispatch => {

        request
          .get(env.tashi + '/projects/' + projectId + '/getUnbilledHours')
          .accept('application/json')
          .withCredentials()
          .end((err, res) => {
            if (err) {
              dispatch(actions.getUnbilledHoursProject({ status: "failure", data: err }));
              return;
            }

            let data = JSON.parse(res.text);

            if (data) {
              dispatch(actions.getUnbilledHoursProject({ status: "success", data: data }));
            } else {
              dispatch(actions.getUnbilledHoursProject({ status: "success", data: [] }));
            }
          })
      }
    }

};

export default projectActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/projectActionCreators.js
 **/